import * as React from "react";
import type { SVGProps } from "react";
const SvgRaysIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="rays_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M905.259 176.085a42.667 42.667 0 0 0-60.331-60.33L559.744 400.896A149.333 149.333 0 0 0 355.84 597.632l-56.875 56.875a149.333 149.333 0 1 0 63.36 57.301l50.859-50.773a149.333 149.333 0 0 0 207.787-200.662l284.288-284.288zM234.667 725.333a64 64 0 1 1 0 128 64 64 0 0 1 0-128zm192-192a64 64 0 1 1 128 0 64 64 0 0 1-128 0z"
    />
  </svg>
);
export default SvgRaysIcon;
